import { Link } from "react-router-dom";
import { useState } from "react";
import { useCreateFormRequestMutation } from "services/api/api";
import { FormRequest } from "services/api/types/FormRequest";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import MaskedInput from "react-text-mask";
import FormResult from "shared/FormResult";
import ModalPopup from "shared/ModalPopup";

const AskModal = ({ setShow }: { setShow: (boolean) => void }) => {
	const [createFormRequest] = useCreateFormRequestMutation();
	const [resultShow, setResultShow] = useState(false);
	const [resultText, setResultText] = useState({
		status: '',
		text: ''
	});
	const phoneNumberMask = [
		"+",
		"7",
		"(",
		/\d/,
		/\d/,
		/\d/,
		")",
		/\d/,
		/\d/,
		/\d/,
		"-",
		/\d/,
		/\d/,
		"-",
		/\d/,
		/\d/
	];
	const validationsSchema = yup.object().shape({
		name: yup.string()
			.min(3, 'Слишком короткое имя')
			.matches(
				/[а-я,А-Я]/,
				'Имя должно содержать только русские буквы'
			)
			.matches(/^([^0-9]*)$/gm, "'Имя должно содержать только буквы")
			.required('Обязательно к заполнению'),
		phone_number: yup.string()
			.required('Обязательно к заполнению')
			.transform(value => value.replace(/[^\d]/g, ''))
			.min(11, "Введите корректный номер"),
		comment: yup.string()
			.test(
				'nourl',
				'Текст сообщения введен некорректно',
				(value) => {
					return !value.match(/(www\.)|(https?:)|(\.ru)|(\.com)|(\.рф)/)
				}
			)
			.required('Обязательно к заполнению'),
	});
	return (
		<>
			{resultShow && resultText.status === 'Спасибо!'
				? <ModalPopup setShow={setShow} addedClass="form_result">
					<FormResult status={resultText.status} text={resultText.text} />
				</ModalPopup>
				: <div id="callback" className="modals-content">
					<div className="modals-inner">
						<div className="modals-inner-capt text-center">Оставить заявку</div>
						<p className="modals-inner-subcapt">Оставьте заявку на необходимый товар и мы подберем для Вас предложение по выгодной цене.</p>
						<Formik
							initialValues={{
								name: '',
								phone_number: '',
								comment: ''
							}}
							validateOnBlur
							onSubmit={async ({ name, phone_number, comment }, { resetForm }) => {
								const body: FormRequest = {
									name,
									phone_number,
									comment
								};
								let res = await createFormRequest({ body });
								if (res['error']) {
									setResultShow(true);
									setResultText({
										status: 'Ошибка!',
										text: `Попробуйте позже`
									});
								} else {
									resetForm();
									setResultShow(true);
									setResultText({
										status: 'Спасибо!',
										text: `Ваша заявка отправлена`
									});
								}
							}}
							validationSchema={validationsSchema}
						>
							{({
								handleSubmit,
								isSubmitting
							}) => (
								<Form className="text-center ajax_form af_call order-form feedback" onSubmit={handleSubmit}>
									<div className="form-group">
										<Field
											type="text"
											name="name"
											placeholder="Ваше имя" />
										<ErrorMessage name="name" component="span" className="error-el left-text" />
									</div>
									<div className="form-group">
										<Field name="phone_number">
											{({ field }) => <MaskedInput
												{...field}
												mask={phoneNumberMask}
												id="phone_number"
												placeholder="Телефон"
												type="text"
											/>
											}
										</Field>
										<ErrorMessage name="phone_number" component="span" className="error-el left-text" />
									</div>
									<div className="form-group">
										<Field
											as="textarea"
											name="comment"
											placeholder="Текст сообщения" />
										<ErrorMessage name="comment" component="span" className="error-el left-text" />
									</div>
									<div className="policy-form text-left mr-bt-20">
										Отправляя любую форму на сайте, вы даете согласие на обработку персональных данных - <Link to="/politika-konfidenczialnosti" itemProp="url">Положение о защите персональных данных</Link>
									</div>
									<button type="submit" disabled={isSubmitting}>Отправить</button>
								</Form>
							)}
						</Formik>
					</div>
					{resultShow && <ModalPopup setShow={setResultShow} addedClass="form_result">
						<FormResult status={resultText.status} text={resultText.text} />
					</ModalPopup>}
				</div>
			}
		</>

	);
};
export default AskModal;